angular.module('myApp.services')
    .factory('userMediaStream', ['clientTools', '$rootScope', function(clientTools, $rootScope) {
        var isAdjustConstraints = true; //Adjust according to bandwidth.
        var quality             = [
            {
                'limit': 0.4,   //upload speed in mb
                'rate': 5,
                'size': {
                    'desktop': {'width': 160, 'height': 120},
                    'mobile': {'width': 160, 'height': 120}
                }
            },
            {
                'limit': 1,
                'rate': 10,
                'size': {
                    'desktop': {'width': 320, 'height': 240},
                    'mobile': {'width': 160, 'height': 120}
                }
            },
            {
                'limit': 2,
                'rate': 15,
                'size': {
                    'desktop': {'width': 640, 'height': 480},
                    'mobile': {'width': 320, 'height': 240}
                }
            },
            {
                'limit': 100,
                'rate': 20,
                'size': {
                    'desktop': {'width': 640, 'height': 480},
                    'mobile': {'width': 320, 'height': 240}
                }
            }
        ];
        var defaultConstraints  = {
            'audio' : {
                echoCancellation: true,
                googEchoCancellation: true,
                googAutoGainControl: true,
                googNoiseSuppression: true,
                googHighpassFilter: true,
                googNoiseReduction: true,
                googTypingNoiseDetection: true,
                googAudioMirroring: true
            },
            'video' : {
                width: quality[3].size.desktop.width,
                height: quality[3].size.desktop.height,
                frameRate: quality[3].rate             //Only for Chrome works
            }
        };
        var mediaDevices = {
            'video': [],
            'audio': []
        };
        var selectedUserMediaDevices = {
            'video': null,
            'audio': null
        };
        var videoSizes = {
            'big': 'big',
            'medium': 'medium',
            'small': 'small'
        };
        var defaultVideoSize = videoSizes.big;
        var streams = {};  //User media stream.

        return {
            getConstraints: function() {
                if (clientTools.isMobileLayout()) {
                    defaultConstraints.video.width  = quality[3].size.mobile.width;
                    defaultConstraints.video.height = quality[3].size.mobile.height;
                }
                var audioSource = this.getUserMediaDevice('audio') ? this.getUserMediaDevice('audio').id : null;
                var videoSource = this.getUserMediaDevice('video') ? this.getUserMediaDevice('video').id : null;
                defaultConstraints.audio.deviceId = audioSource ? {exact: audioSource} : undefined;
                defaultConstraints.video.deviceId = videoSource ? {exact: videoSource} : undefined;
                if (isAdjustConstraints) {
                    var bandwidth = clientTools.getInternetSpeed();
                    if (bandwidth.upload) {
                        var speed   = bandwidth.upload;
                        var index   = quality.length -1;
                        for (var i = 0; i < quality.length; i++) {
                            if (speed <= quality[i].limit) {
                                index = i;
                                break;
                            }
                        }
                        defaultConstraints.video.width      = quality[index].size.desktop.width;
                        defaultConstraints.video.height     = quality[index].size.desktop.height;
                        defaultConstraints.video.frameRate  = quality[index].rate;
                        if (clientTools.isMobileLayout()) {
                            defaultConstraints.video.width  = quality[index].size.mobile.width;
                            defaultConstraints.video.height = quality[index].size.mobile.height;
                        }
                        if (index === 0) {
                            defaultVideoSize = videoSizes.small;
                        } else if (index === 1) {
                            defaultVideoSize = videoSizes.medium;
                        } else {
                            defaultVideoSize = videoSizes.big;
                        }
                    }
                }
                var newConstraints = {};
                angular.copy(defaultConstraints, newConstraints);
                return newConstraints;
            },
            getDefaultVideoSize: function () {
                return defaultVideoSize;
            },
            setStream: function(userMediaStream, qId) {
                streams[qId]  = userMediaStream;
                $rootScope.$broadcast("userMediaStreamAdded", {'qId': qId});
            },
            setUserMediaDevice: function(type, device) {
                selectedUserMediaDevices[type] = device;
            },
            getUserMediaDevice: function(type) {
                return selectedUserMediaDevices[type];
            },
            getCurrentlyPlayingUserMediaDevice: function(type, qId) {
                var stream  = this.getStream(qId);
                var device  = null;
                if (stream) {
                    var tracks = type == 'video' ? stream.getVideoTracks() : stream.getAudioTracks();
                    if (tracks.length) {
                        device = tracks[0];
                    }
                }
                return device;
            },
            getStream: function(qId) {
                if (qId in streams) {
                    return streams[qId];
                }
                return null;
            },
            stopStream: function(qId) {
                if (qId in streams) {
                    streams[qId].getTracks().forEach(function(track) {
                        track.stop();
                    });
                    delete streams[qId];
                }
            },
            setDevices: function(deviceInfos) {
                mediaDevices = {
                    'video': [],
                    'audio': []
                };
                for (var i = 0; i !== deviceInfos.length; ++i) {
                    var deviceInfo = deviceInfos[i];
                    if (deviceInfo.kind === 'audioinput') {
                        mediaDevices.audio.push({
                            'id': deviceInfo.deviceId,
                            'label': deviceInfo.label || 'Microphone ' + (mediaDevices.audio.length + 1)
                        });
                    } else if (deviceInfo.kind === 'videoinput') {
                        mediaDevices.video.push({
                            'id': deviceInfo.deviceId,
                            'label': deviceInfo.label || 'Camera ' + (mediaDevices.video.length + 1)
                        });
                    }
                }
                $rootScope.$broadcast("userMediaDevices");
            },
            getDevices: function() {
                return mediaDevices;
            },
            setUserMediaError: function(err, qId) {
                $rootScope.$broadcast("userMediaError", {'err': err, 'qId': qId});
            }
        }
    }]);